import * as React from 'react'
import { Query } from 'react-apollo'

import Loader from 'main/components/common/Loader'
import { ExternalSchoolFields as IExternalSchool } from 'main/gql/externalSchool'
import { User, USER_QUERY, User_user } from 'main/gql/user'
import { Modal } from 'main/ui'

import Confirmation from './steps/Confirmation'
import Join from './steps/Join'
import { Step } from './types'

interface IProps {
  externalSchool: IExternalSchool
  onClickRemove: () => void
  onRequestClose: () => void
}

function JoinModal(props: IProps) {
  const { externalSchool, onClickRemove, onRequestClose } = props
  const [step, setStep] = React.useState<Step>(Step.Join)

  return (
    <Query<User> query={USER_QUERY}>
      {({ data, error, loading }) => (
        <Modal title={modalTitle(step)} kind={modalKind(step)} onRequestClose={onRequestClose}>
          {loading || error || !data ? (
            <Loader />
          ) : (
            modalContent(step, data.user, externalSchool, setStep, onRequestClose, onClickRemove)
          )}
        </Modal>
      )}
    </Query>
  )
}

function modalContent(
  step: Step,
  user: User_user | null,
  externalSchool: IExternalSchool,
  onChangeStep: React.Dispatch<React.SetStateAction<Step>>,
  onRequestClose: () => void,
  onClickRemove: () => void,
) {
  switch (step) {
    case Step.Join:
      return (
        <Join
          user={user}
          externalSchool={externalSchool}
          onChangeStep={onChangeStep}
          onClickRemove={onClickRemove}
        />
      )
    case Step.Confirmation:
      return <Confirmation onRequestClose={onRequestClose} />
    case Step.ConfirmationWithPassword:
      return <Confirmation showPasswordForm onRequestClose={onRequestClose} />
  }
}

function modalTitle(step: Step) {
  switch (step) {
    case Step.Join:
      return 'Join Wonderschool'
    case Step.Confirmation:
    case Step.ConfirmationWithPassword:
      return 'Thank you!'
  }
}

function modalKind(step: Step) {
  switch (step) {
    case Step.Join:
      return 'large'
    case Step.Confirmation:
    case Step.ConfirmationWithPassword:
      return 'normal'
  }
}

export default React.memo(JoinModal)
